import {useRemainingTime} from '@aboutyou/i18n';

export const useIsTakeoverActive = ({
  startsAt,
  endsAt,
}: {
  startsAt?: Date;
  endsAt?: Date;
}): boolean => {
  const remainingStart = useRemainingTime(startsAt);
  const remainingEnd = useRemainingTime(endsAt);
  return remainingStart <= 0 && remainingEnd > 0;
};
